import { Box, Button, FormControl, FormGroup, FormLabel, MenuItem, Modal, Select, Typography } from "@mui/material";
import { Voucher } from "pages/voucher-management/VoucherType";
import { useEffect, useState } from "react";
import { Customer } from "./CustomerType";
import { getPrivateVoucherOptions } from "services/VoucherService";
import { getCustomerOptions } from "services/CustomerService";

interface CustomerSendVoucherModalProps {
    open: boolean;
    onClose: () => void;
    initialValues: number[];
    reloadTableData: () => Promise<void>;
}

export type CustomerSendVoucher = {
    voucherId: number;
}

const CustomerSendVoucherModal = ({ open, onClose, initialValues, reloadTableData }: CustomerSendVoucherModalProps) => {
    const [vouchers, setVouchers] = useState<Voucher[]>([]);
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [voucherId, setVoucherId] = useState<number>(0);
    const [customerIds, setCustomerIds] = useState<number[]>(initialValues);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    useEffect(() => {
        getVoucherAndCustomerOptions();
    }, []);

    useEffect(() => {
        console.log(initialValues);
        setCustomerIds(initialValues);
    }, [initialValues]);

    const getVoucherAndCustomerOptions = async () => {
        const response = await getPrivateVoucherOptions();
        const customers = await getCustomerOptions();
        setVouchers(response);
        setCustomers(customers);
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        // await sendVoucher(voucherId, customerIds);
        await reloadTableData();
        setErrors({});
        onClose();
    }

    return <Modal open={open} onClose={onClose}>
        <Box
            component="form"
            sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}
            onSubmit={handleSubmit}
            >
                <Typography variant="h6">Gửi voucher khách hàng</Typography>
                <FormGroup>
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <FormLabel htmlFor="voucher">Mã voucher</FormLabel>
                        <Select
                        id="voucher"
                        name="voucher"
                        required
                        // fullWidth
                        variant="outlined"
                        value={voucherId}
                        onChange={(e) => setVoucherId(Number(e.target.value))}
                        error={!!errors.voucher}
                        color={errors.voucher ? 'error' : 'primary'}
                        >
                            {vouchers.map((voucher: Voucher) => (
                                <MenuItem key={voucher.id} value={voucher.id}>{voucher.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <FormLabel htmlFor="customers">Danh sách khách hàng</FormLabel>
                        <Select
                        id="customers"
                        name="customers"
                        required
                        // fullWidth
                        variant="outlined"
                        value={customerIds}
                        onChange={(e) => setCustomerIds(e.target.value as number[])}
                        error={!!errors.customerIds}
                        color={errors.customerIds ? 'error' : 'primary'}
                        multiple
                        >
                            {customers.map((customer: Customer) => (
                                <MenuItem key={customer.id} value={customer.id}>{customer.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </FormGroup>
                <Typography variant="body1" sx={{ mt: 2 }}>Số lượng khách hàng: {customerIds.length}</Typography>
                <Box mt={2} display="flex" justifyContent="flex-end">
                <Button onClick={onClose} sx={{ mr: 1 }}>Cancel</Button>
                <Button type="submit" variant="contained" color="primary">Xác nhận</Button>
                </Box>
            </Box>
    </Modal>;
}

export default CustomerSendVoucherModal;
